import { useRouter } from 'next/router'
import React, { FC, memo } from 'react'

import { Price as PriceDefinition, Product } from '@Generated/graphql'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './TitleAndPrice.module.scss'

type TitleAndPriceProps = Pick<Product, 'name'> & Pick<Product, 'id'> & {
  price?: PriceDefinition
}

export const TitleAndPrice: FC<TitleAndPriceProps> = memo(({ id, name, price }) => {
  const { t } = useTranslation()
  const enableTaxAndDuties = useSplitTest('duties_and_taxes_inc_v1', 'b')
  const { locale } = useRouter()
  const isGiftCard = `${id}` === '26342'

  const beforePrice = (price?.discount?.format ? price.format : undefined) || undefined
  const currentPrice = price?.discount?.format || price?.format || ''

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <h1 className={styles.title}>
          {name}
        </h1>

        {!isGiftCard && price && (
          <div className={styles.priceWrapper}>
            {beforePrice && (
              <span className={styles.beforePrice}>{beforePrice}</span>
            )}
            <span className={styles.currentPrice}>
              {currentPrice}
            </span>
          </div>
        )}
      </div>

      {!enableTaxAndDuties && locale === 'nb-NO' && (
        <aside className={styles.taxMessage}>{t('products:INCLUDING_VALUE_ADDED_TAX')}</aside>
      )}
    </div>
  )
})
